import { render, staticRenderFns } from "./HRDesktop.vue?vue&type=template&id=16337d06"
import script from "./HRDesktop.vue?vue&type=script&lang=js"
export * from "./HRDesktop.vue?vue&type=script&lang=js"
import style0 from "./HRDesktop.vue?vue&type=style&index=0&id=16337d06&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports